export enum OrderCardsActionTypes {
  UPDATING_ORDER = 'set-cards/UPDATING_ORDER',
  ORDER_UPDATED = 'set-cards/ORDER_UPDATED',
}
